// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__1L7Ro","btn":"Nav_btn__25gcW"};